<template>
  <v-card>
    <v-card-text class="text-xs-center headline primary--text pb-0">Cadastrando nova cobrança</v-card-text>
    <v-container flex grid-list-lg>
      <v-layout row wrap>
        <v-flex xs5>
          <v-text-field outline label="Valor (R$)" v-money="money" hide-details v-model="tempValor"></v-text-field>
        </v-flex>
        <v-flex xs7>
          <v-select
            outline
            placeholder="Combustível"
            single-line
            clearable
            :items="combustiveis"
            hide-details
            v-model="tempCombustivel"
          >
            <template v-slot:selection="item">
              <v-list-tile-avatar>
                <svg-filler
                  :path="item.item.icone ? require(`@/assets/combs/${item.item.icone}.svg`) : require(`@/assets/combs/gas.svg`)"
                  width="50px"
                  height="50px"
                  :fill="item.item.color"
                />
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title
                  v-text="item.item.nome"
                  class="font-weight-medium"
                  :style="{color: item.item.color}"
                ></v-list-tile-title>
              </v-list-tile-content>
            </template>
            <template v-slot:item="item">
              <v-list-tile-avatar>
                <svg-filler
                  :path="item.item.icone ? require(`@/assets/combs/${item.item.icone}.svg`) : require(`@/assets/combs/gas.svg`)"
                  width="50px"
                  height="50px"
                  :fill="item.item.color"
                />
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title
                  v-text="item.item.nome"
                  class="font-weight-medium"
                  :style="{color: item.item.color}"
                ></v-list-tile-title>
              </v-list-tile-content>
            </template>
          </v-select>
        </v-flex>
        <v-flex xs12>
          <v-textarea outline label="Detalhes da cobrança" v-model="descricao" hide-details></v-textarea>
        </v-flex>
      </v-layout>
    </v-container>
    <v-card-actions>
      <v-btn flat color="grey darken-2" @click="fecharTela()">VOLTAR</v-btn>
      <v-spacer></v-spacer>
      <v-btn flat color="green" @click="criarCobranca()" :loading="loading">CONCLUIR</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { VMoney } from 'v-money'

export default {
  props: ['fatura'],
  data () {
    return {
      money: {
        decimal: '.',
        thousands: '',
        prefix: 'R$ ',
        precision: 2,
        masked: false
      },
      tempValor: null,
      tempCombustivel: null,
      descricao: null
    }
  },
  computed: {
    loading () {
      return this.$store.getters.loading
    },
    combustiveis () {
      return this.$store.getters.combustiveis
    },
    model () {
      return {
        valor: this.tempValor ? this.tempValor.split(' ')[1] : '0',
        descricao: this.descricao,
        combustivel: this.tempCombustivel
          ? this.tempCombustivel.id_combustivel
          : null,
        faturamento_posto: this.fatura ? this.fatura.id : null
      }
    }
  },
  directives: { money: VMoney },
  methods: {
    fecharTela () {
      this.tempValor = null
      this.descricao = null
      this.tempCombustivel = null
      this.$emit('fechar')
    },
    criarCobranca () {
      this.$store
        .dispatch('criarCobranca', this.model)
        .then(() => {
          this.fecharTela()
        })
        .catch(() => {
          this.fecharTela()
        })
    }
  }
}
</script>
